import LAYOUT from '@/layout/layout';
import moduleLayout from '@/modules/OperatorPanel/layout/Layout.vue';
import dashboardLayout from '@/modules/OperatorPanel/layout/DashboardsLayout.vue';

export default [
  {
    path: '/operator_panel',
    component: LAYOUT.base,
    name: 'OperatorPanel',
    redirect: '/operator_panel/chats',
    children: [
      {
        path: 'chats',
        component: moduleLayout,
        children: [
          {
            path: '',
            name: 'OperatorPanelChats',
            component: () => import(/* webpackChunkName: 'op-chats' */ '@/modules/OperatorPanel/views/chats/ChatsTab.vue'),
          },
        ],
      },
      {
        path: 'chats-search',
        component: moduleLayout,
        children: [
          {
            path: '',
            name: 'OperatorPanelChatsSearch',
            component: () => import(/* webpackChunkName: 'op-chats' */ '@/modules/OperatorPanel/views/chats/ChatsSearchTab.vue'),
          },
        ],
      },
			{
				path: 'statistic_real_time',
				name: 'OperatorPanelRealtimeBoard',
				component: () => import(/* webpackChunkName: 'op-chats' */ '@/modules/OperatorPanel/views/dashboard/RealtimeBoard.vue'),
			},
			{
				path: 'dashboard',
				component: dashboardLayout,
				children: [
					{
						path: '',
						name: 'OperatorPanelDashboard',
						component: () => import(/* webpackChunkName: 'op-chats' */ '@/modules/OperatorPanel/views/dashboard/Dashboard.vue'),
					},
				],
			},
			{
				path: 'operator_helper',
				name: 'OperatorHelper',
				component: () => import(/* webpackChunkName: 'op-chats' */ '@/modules/OperatorPanel/views/OperatorHelper.vue'),
			},
			{
				path: 'table-view',
				component: moduleLayout,
				children: [
					{
						path: '',
						name: 'OperatorPanelTableView',
						component: () => import(/* webpackChunkName: 'op-chats' */ '@/modules/OperatorPanel/views/tableView/TableView.vue'),
					},
				],
			},
    ],
  },
];
